export default __webpack_public_path__ + "static/media/tarima10.1306c2f2.png";